import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
    buttons: {
        primary: string;
        secondary: string | null;
    };
    content: string;
    iconClass: string;
    title: string;
    type: string;
    showUnderstoodCheckbox: boolean;
}

@Component({
    selector: 'via-generic-modal',
    templateUrl: './generic-modal.component.html',
    styleUrls: ['./generic-modal.component.scss'],
})
export class GenericModalComponent {
    public isUnderstoodChecked: boolean = false;

    constructor(public dialogRef: MatDialogRef<GenericModalComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    public onClick(): void {
        if (this.isUnderstoodChecked) {
            localStorage.setItem(this.data.type, 'false');
        }
    }
}
